import React, { useState, useEffect } from "react"
import { withAuthorization } from "../../higher-order-components/AuthorizationHOC"
import { PageAuthorizations } from "../../../auth/pageAuthorization"
import { getOneHearingInstrument } from "../../../services/ManageHearingInstruments"
import { withRouter } from "../../../helper/withrouter"
import Loading from "../../loading"
import PropTypes from "prop-types"

export const HearingInstrumentDetails = (props) => {
  const [isLoading, setIsLoading] = useState(false)
  const [hearingInstrumentDetails, setHearingInstrumentDetails] = useState(null)

  const fetchHearingInstruments = async () => {
    setIsLoading(true)
    let hearingInstrumentDetails = await getOneHearingInstrument(
      props.params.id
    )
    setHearingInstrumentDetails(hearingInstrumentDetails.data)
    setIsLoading(false)
  }
  useEffect(() => {
    fetchHearingInstruments()
  }, [])

  return (
    <>
      {isLoading ? (
        <Loading isLoading={isLoading} />
      ) : (
        <div className="container-fluid">
          <div className="col">
            <h2>Hearing Instrument Details</h2>
            <pre style={{ whiteSpace: "pre-wrap" }}>
              {JSON.stringify(hearingInstrumentDetails, null, 2)}
            </pre>
          </div>
        </div>
      )}
    </>
  )
}
HearingInstrumentDetails.propTypes = {
  params: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
}

export default withAuthorization(
  withRouter(HearingInstrumentDetails),
  PageAuthorizations.HearingInstrumentDetails.authorizedRoles
)
